import usePCFStore from '../../../store/pcfStore/pcfStore';

export const useExpertMode = (): boolean =>
  usePCFStore((state) => Boolean(state.recordData.goalAndScope?.expertMode));
